export default __webpack_public_path__ + "static/media/dyeing11.fcd12437.png";